import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import { Alert,  Row, Col } from 'reactstrap';
import { Afr, getSelectedAfr } from '../../redux/AfrSlice';
import enums from '../../utils/enums';
import utilityHelper from '../../utils/utilityHelper';
import { getTaxonomyType } from '../../redux/MiscSlice';
import { TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';



const ShowAFRMessage = function () {

    var location = useLocation();
    var currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    var taxonomyType: TaxonomyTypeEnum | null = useAppSelector(getTaxonomyType);
    const [reportType, setReportType] = React.useState<string>('AFR');

    const showIfPathNameNotContains = function () {
        const list: Array<string> = [];

        list.push("/AFRAssignment");
        list.push("/AdminMenu");
        list.push("/ErrorsA");
        list.push("/PublicReports");

        const index = list.findIndex(path => path === location.pathname);


        if (index === -1) { return true}
        return false;
    }

    React.useEffect(() => {
        
        switch (taxonomyType) {

            case TaxonomyTypeEnum.AFR:
                setReportType('AFR');
                break;

            case TaxonomyTypeEnum.COURT_REPORTING_939:
                setReportType('939.185 Court Report');
                break;

            case TaxonomyTypeEnum.COURT_REPORTING_29:
                setReportType('29.0085 Court Report');
                break;

                
            default:
                setReportType('AFR');
                break;
        }
             
    }, [taxonomyType])

    return (
        
        
        <React.Fragment>
            { showIfPathNameNotContains() &&
               ( <Row>
                <Col md="10">
                    { currentAfr
                        ?
                        <div>
                            {(utilityHelper.IsAFRVerified(currentAfr)) &&
                                (<Alert color="danger">
                                <p>This {reportType} is no longer available for editing. Please email localgov@myfloridacfo.com for assistance.</p>
                                </Alert>)}
                            {(utilityHelper.IsReportedByPrimary(currentAfr) && currentAfr.affiliateReportingForAfr && currentAfr.affiliateReportingForAfr.affiliateReference) &&
                                (<Alert color="danger">
                                <p>This AFR is being dependently reported (<b>{enums.rptTypeOptions[currentAfr.affiliateReportingForAfr.reportingType]}</b>) by it's primary Government (<b>{currentAfr.affiliateReportingForAfr.affiliateReference.name}</b>).<br />Please consult the Primary AFR for details.</p>
                                </Alert>)}
                        </div>
                        : <div></div>
                    }
                    </Col>

                </Row>)
            }
        </React.Fragment >
    )

}

export default ShowAFRMessage;